export const mapProjectDto = (dto) => ({
    id: dto.id,
    name: dto.name,
    description: dto.description,
    companyId: dto.companyId,
    companyName: dto.companyName
});

